import AgGridSelect from '@components/ag-grid-helpers/AgGridSelect'
import { dateRenderer } from '@lib/generic.utils'

export default {
  computed: {
    gridOptions() {
      return {
        frameworkComponents: {
          'ag-grid-select': AgGridSelect
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        domLayout: 'normal',
        defaultColDef: {
          floatingFilter: true,
          filter: 'agTextColumnFilter'
        },
        context: {
          sortColumn: 4,
          sortOrder: 'desc'
        },
        rowData: this.subscriptions,
        columnDefs: [
          {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: 'Subscription name',
            field: 'subscription.name'
          },
          {
            headerName: 'Detail',
            field: 'name_reference'
          },
          {
            headerName: 'Publisher name',
            field: 'publisher.name'
          },
          {
            headerName: 'Vendor name',
            field: 'vendor.name'
          },
          {
            headerName: 'Start date',
            field: 'start_date',
            cellRenderer: params => dateRenderer(params.data.start_date),
            valueGetter: params => dateRenderer(params.data.start_date)
          },
          {
            headerName: 'End date',
            field: 'end_date',
            cellRenderer: params => dateRenderer(params.data.end_date),
            valueGetter: params => dateRenderer(params.data.end_date)
          },
          {
            headerName: 'Financial period',
            field: 'financial_period',
            editable: true,
            cellRenderer: params =>
              `${this.formatDateForLocale(params.data.financial_period.start_date)} - ${this.formatDateForLocale(
                params.data.financial_period.end_date
              )}`,
            cellEditor: 'ag-grid-select',
            cellEditorParams: params => {
              return {
                options: this.financialPeriodOptions,
                selected: {
                  label: `${this.formatDateForLocale(
                    params.data.financial_period.start_date
                  )} - ${this.formatDateForLocale(params.data.financial_period.end_date)}`,
                  value: params.data.financial_period
                },
                getValueFromParent: selected => {
                  return selected.value
                }
              }
            }
          }
        ]
      }
    }
  }
}
